import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { captureException } from '@sentry/react';

import { authorizedAxiosInstance } from '@/clients';
import { useWorkspaceWebSocket } from '@/hooks/useWorkspaceWebSocket';

// import { useWorkspaceWebSocket } from '@/hooks/useWorkspaceWebSocket';

const RealtimeContext = createContext<{ wsRef: React.MutableRefObject<WebSocket | null> } | null>(null);

const { Provider } = RealtimeContext;

export function useWSToken() {
    const [token, setToken] = useState<string>('');

    useEffect(() => {
        async function connect() {
            try {
                const res = await authorizedAxiosInstance.post('/auth/ws');

                const { token } = res.data;

                setToken(token);
            } catch (err) {
                captureException(err);
            }
        }

        connect();
    }, []);

    if (!token) {
        return;
    }

    return token;
}

export const RealtimeProvider = ({ children }: { children: React.ReactNode }) => {
    const token = useWSToken();
    const wsRef = useWorkspaceWebSocket(token!);

    const value = useMemo(() => ({ wsRef }), [wsRef]);

    return <Provider value={value}>{children}</Provider>;
};

export const useRealtime = () => {
    const ctx = useContext(RealtimeContext);

    if (!ctx) {throw new Error('useRealtime must be used within RealtimeProvider');}

    return ctx;
};
